import React from 'react';
import { ArrowRight } from 'lucide-react';

const QuizQuestion = ({ question, onAnswer, selectedAnswer, onNext, isLastQuestion, loading }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-green-800">{question.question}</h3>
      <div className="space-y-3">
        {question.options.map((option, index) => (
          <button
            key={index}
            onClick={() => onAnswer(option)}
            className={`w-full text-left p-4 rounded-lg border transition-all ${
              selectedAnswer === option
                ? 'border-green-500 bg-green-50 text-green-800'
                : 'border-gray-200 hover:border-green-300 hover:bg-green-50/50'
            }`}
          >
            {option}
          </button>
        ))}
      </div>
      <div className="flex justify-end">
        <button
          onClick={onNext}
          disabled={!selectedAnswer || loading}
          className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all ${
            selectedAnswer && !loading
              ? 'bg-green-500 text-white hover:bg-green-600'
              : 'bg-gray-200 text-gray-500 cursor-not-allowed'
          }`}
        >
          {loading ? (
            'Processing...'
          ) : (
            <>
              {isLastQuestion ? 'Get Results' : 'Next Question'}
              <ArrowRight className="w-5 h-5" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default QuizQuestion; 